import React from "react";
import HPOClasses from "./HPOConstants";

function HPOLegend() {
  return (
    <>
      <div className="varsome-text-center">
        <p>You can click on a disease to expand its phenotypes</p>
      </div>
      <div className="tw-flex tw-full tw-items-center tw-pb-4">
        <div className="tw-flex-grow" />
        <div className={`${HPOClasses.gene} tw-w-4 tw-h-4 tw-mr-1`} />
        <div className="tw-mr-12">Gene</div>
        <div className={`${HPOClasses.disease} tw-w-4 tw-h-4 tw-mr-1`} />
        <div className="tw-mr-12">Disease</div>
        <div className={`${HPOClasses.phenotype} tw-w-4 tw-h-4 tw-mr-1`} />
        <div>Phenotype</div>
        <div className="tw-flex-grow" />
      </div>
    </>
  );
}

export default HPOLegend;
